import QRCode from 'qrcode';
import html2canvas from 'html2canvas';
import * as service from './service';

const services = { ...service };

const state = {
  shareInfo: {},
  imageList: [],
  QRCode: '',
  shareImage: '',
};

const mutations = {
  setShareInfo(state, obj) {
    state.shareInfo = obj;
  },
  setImageList(state, list) {
    state.imageList = list;
  },
  setQRCode(state, str) {
    state.QRCode = str;
  },
  setShareImage(state, str) {
    state.shareImage = str;
  },
};

const actions = {
  // 事件
  getShareInfo({ commit }) {
    return services.getShareInfo().then((res) => {
      commit('setShareInfo', res.data);
    });
  },
  async generateShareImage({ dispatch }, { imageList = [], url = '', className = '' }) {
    dispatch('canvasToBlobPolyfill');
    await Promise.all([dispatch('preloadAll', imageList), dispatch('getQRCode', url)]);
    const canvas = await dispatch('html2canvas', className);
    dispatch('canvas2shareImage', canvas);
  },
  // 步骤
  canvasToBlobPolyfill() {
    if (!HTMLCanvasElement.prototype.toBlob) {
      Object.defineProperty(HTMLCanvasElement.prototype, 'toBlob', {
        value: function (callback, type, quality) {
          var binStr = atob(this.toDataURL(type, quality).split(',')[1]),
            len = binStr.length,
            arr = new Uint8Array(len);

          for (var i = 0; i < len; i++) {
            arr[i] = binStr.charCodeAt(i);
          }

          callback(new Blob([arr], { type: type || 'image/png' }));
        },
      });
    }
  },
  async preloadAll({ commit, dispatch }, imageList) {
    const preloadImgList = imageList.map((item) => dispatch('preloadImg', item));
    const res = await Promise.all(preloadImgList);
    commit('setImageList', res);
    return res;
  },
  preloadImg(context, url) {
    return new Promise((resolve, reject) => {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      const img = new Image();
      img.crossOrigin = 'anonymous';
      img.src = url;
      img.onload = () => {
        canvas.width = img.width;
        canvas.height = img.height;
        ctx.drawImage(img, 0, 0);
        canvas.toBlob((blob) => {
          const blobURL = URL.createObjectURL(blob);
          resolve(blobURL);
        });
      };
      img.onerror = (error) => {
        reject(error);
      };
    });
  },
  getQRCode({ commit }, url) {
    return new Promise((resolve, reject) => {
      QRCode.toCanvas(url, {
        margin: 0,
      })
        .then((canvas) => {
          canvas.toBlob((blob) => {
            const blobURL = URL.createObjectURL(blob);
            commit('setQRCode', blobURL);
            resolve(blobURL);
          });
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  html2canvas(context, className) {
    return html2canvas(document.querySelector(className), {
      useCORS: true,
      scale: 1,
      scrollY: -window.pageYOffset,
    }).then((canvas) => {
      return canvas;
    });
  },
  canvas2shareImage({ commit }, canvas) {
    return new Promise((resolve, reject) => {
      const type = 'image/jpeg';
      const encoderOptions = 0.6;
      const ua = window.navigator.userAgent;
      const isIOS = ua.indexOf('like Mac OS X') > -1;
      if (isIOS || process.env.VUE_APP_ENV === 'development') {
        const shareImage = canvas.toDataURL(type, encoderOptions);
        commit('setShareImage', shareImage);
        resolve(shareImage);
      } else {
        canvas.toBlob(
          (blob) => {
            const formData = new FormData();
            formData.append('file', blob);
            services
              .uploadImage(formData)
              .then((res) => {
                const shareImage = res.data.url;
                commit('setShareImage', shareImage);
                resolve(shareImage);
              })
              .catch((error) => {
                reject(error);
              });
          },
          type,
          encoderOptions
        );
      }
    });
  },
};

export default {
  namespaced: true,
  services,
  state,
  mutations,
  actions,
};
